const TRANSLATION = {
  buyModal: {
    afterFree: 'Pagkatapos ng iyong libreng pagsubok',
    btn: 'Subukan nang Libre',
    freeTrial: '3-Araw na Libreng Pagsubok',
    monthLabel: 'buwan',
    selectLabel: 'Pumili ng plano',
    title: 'Plano ng Subscription',
    yearLabel: 'taon',
  },
  contact: {
    block1:
      'Para sa customization, mga tanong, o mungkahi, mangyaring makipag-ugnayan sa amin sa contact@noam.tools. Magrereply kami kaagad.',
    block2:
      'Suportahan kami sa pamamagitan ng pagbibigay ng rating sa amin sa Google Apps Extension store sa ★★★★★.',
    block3: 'Tulungan ang iba sa pamamagitan ng pagbabahagi ng extension na ito:',
    title: 'Kontakin Kami',
  },
  help: {
    AquickOverviewOfNoam: 'Isang Mabilis na Pananaw sa Noam',
    ChatPDF: 'Chat PDF',
    ChatPDF2: 'ChatPDF',
    FavoritesManagement: 'Pamamahala ng Mga Paborito',
    Fixedplugin: 'Naayos na Plugin',
    Focusing: 'Pagtuon',
    Free: 'Libreng',
    FreeTrialBenefits: 'Mga Benepisyo ng Libreng Pagsubok',
    GoWithWikipedia: 'Sumunod sa Wikipedia',
    GoWithYouTube: 'Sumama sa YouTube',
    HoverTranslation: 'Pagsasalin sa Hover',
    Howtouse: 'Paano Gamitin',
    ImageTranslation: 'Pagsasalin ng Larawan',
    InstantTranslation: 'Instant Translasyon',
    Membership: 'Miyembro',
    NoamHelp: 'Tinutulungan ka ni Noam na magsalin at magbubuod',
    PDFparallelTranslation: 'Pantay na Pagsasalin ng PDF',
    ParallelTranslation: 'Parallel na Pagsasalin',
    SkipAllSteps: 'Laktawan ang Lahat ng Hakbang',
    Summary: 'Buod',
    Translation: 'Pagsasalin',
    TryItForFree: 'Subukan Ito nang Libre',
    Video: 'Video',
    VideoSummary: 'Buod ng Video',
    VideoTranslation: 'Pagsasalin ng Video',
    WebSummary: 'Buod ng Web',
    WordSelectionTranslation: 'Pagsasalin ng Pagpili ng Salita',
    benefits: 'May mga benepisyo kaming hinihintay para sa iyo!',
    dayFree: '3-Araw na Libreng Pagsubok',
    done: 'Tapos',
    next: 'Susunod',
    pin: 'I-pin si Noam para sa Mas Madaling Pag-access～～',
    planIsNotExist: 'Ang plano ay hindi available',
    startWiki: 'Simulan na natin ang Wikimedia!',
    startYoutube: 'Simulan na natin ang YouTube!',
    try: 'Subukan Ito',
    tryNow: 'Subukan mo na ngayon!',
  },
  home: {
    PDFTranslate: {
      desc: 'Dual na Wika na Pagsasalin + Chat PDF',
      sub1: {
        desc: 'Ang binilinggwal na pagbabasa ay nagbibigay-daan sa iyo na ihambing ang orihinal na teksto at ang pagsasalin nang magkatabi, na nagpapabuti sa kahusayan ng pagbabasa.',
        title: 'Bilinggwal na Pagbabasa',
      },
      sub2: {
        desc: 'Nag-aanalisa at nagsusumaryo ang AI, at maaari nitong sagutin ang iyong mga tanong batay sa nilalaman ng PDF.',
        title: 'Chat PDF',
      },
      sub3: {
        desc: 'AI-powered na pagsasalin ng PDF para sa higit na katumpakan at kahusayan.',
        title: 'Kumpletong Katumpakan at Kahusayan',
      },
      title: 'I-translate ang PDF',
    },
    aiAssistant: {
      desc: 'Ginagawang Mas Matalino at Mas Maginhawa ang Pagsasalin sa Web',
      panel1: {
        desc: 'Ang mga dalawang-wika na cross-referencing na pagsasalin ay tumutulong sa iyo na ihambing ang orihinal na teksto sa pagsasalin upang mas maunawaan mo ito at mapabuti ang iyong kahusayan sa pagbabasa.',
        title: 'Dual-wika na Pagsasalin',
      },
      panel2: {
        left: {
          desc: 'Kapag nagba-browse ng web page, i-hover ang cursor sa nilalaman na kailangan mong isalin upang makita ang pagsasalin.',
          title: 'Hover Pagsasalin',
        },
        right: {
          desc: 'Kapag nagba-browse ng web page, piliin ang teksto na nais mong isalin upang makita ang pagsasalin.',
          title: 'Pagsasalin ng Piliing Teksto',
        },
      },
      panel3: {
        one: {
          desc: 'Isalin at buod ang mga web page at nilalaman ng video kahit kailan, kahit saan, para sa mas maayos na karanasan!',
          title: 'Pindot at I-click',
        },
        three: {
          desc: 'Ang malaking modelo ng wika na pinanghahawakan ng AI ay nagsisiguro ng katumpakan at pagkakapare-pareho ng pagsasalin para sa pinahusay na karanasan sa pagbabasa.',
          title: 'Pinangungunahan ng AI',
        },
        two: {
          desc: 'Pangkalahatang saklaw ng maraming wika, walang hadlang na pagbabasa sa dalawang wika, isang klik na pagsasalin - maranasan ang pagkakaiba!',
          title: 'Mas Komprehensibo at Maginhawa',
        },
      },
      panel4: {
        tab1: {
          desc: 'Ang iyong eksperto sa kahusayan - gamit ang ChatGPT, nagsasalin at nagsusumaryo si Noam ng nilalaman ng video sa YouTube upang makatipid ka ng oras!',
          key: 'Bidyo',
          title: 'Pagsasalin at Buod ng Video',
        },
        tab2: {
          desc: 'I-click upang isalin ang mga larawan habang nagba-browse sa web.',
          key: 'Larawan',
          title: 'Pagsasalin ng Larawan',
        },
        tab3: {
          desc: 'Agad na kinukuha ang mga pangunahing impormasyon mula sa mga web page at nagbibigay ng buod, na nagpapabuti sa iyong kahusayan sa pagbabasa.',
          key: 'Web',
          title: 'Web Translate at Buod',
        },
        tag1: 'Simpleng',
        tag2: 'Epektibo',
        tag3: 'Madaling Intindihin',
      },
      title: 'AI Asistente',
    },
    getStart: 'Magsimula',
    getStartedForFree: 'Mag simula nang libre',
    howItWork: {
      desc: 'Pinagsasama-sama ni Noam ang mga modelo ng AI upang mabigyan ang mga user ng isang matalinong karanasan para sa cross-language na pagsasalin at pagsasama-sama ng web page, pagsasalin ng PDF at imahe, pagsasalin at pagsasama-sama ng video',
      title: 'Paano ito gumagana',
    },
    lastBlock: {
      desc: 'Mas mahusay na AI translation para sa mas maayos na karanasan sa pagbabasa',
    },
    top: {
      desc: 'Ang Noam ay isang libreng AI browser extension na tumutulong sa iyo na mag-translate at mag-summary ng mga web page, video, at PDF content.\n      Sumali sa Noam at maranasan ang magic!',
      title1: 'Isang Magic',
      title2: 'Isang Click',
    },
    userReviews: {
      desc: 'Limang-bitwin na pagsusuri sa Chrome Web Store',
      title: 'Mga Puna ng User',
    },
  },
  installTips: {
    btn: 'Subukan Na Ito',
    text: 'I-install ang "Noam Browser Plugin" para ma-unlock ang mga karagdagang feature! Web cross-referencing,\n    web video summarization, at marami pang iba!',
  },
  locale: {
    af: 'Afrikaans',
    am: 'Amharic',
    ar: 'Arabik',
    as: 'Assamese',
    auto: 'Awto-detekta',
    az: 'Azerbaijani',
    ba: 'Bashkir',
    bg: 'Bulgaryo',
    bn: 'Bangla',
    bo: 'Tibetano',
    bs: 'Bosniak',
    ca: 'Katalan',
    cs: 'Tsek',
    cy: 'Welsh',
    da: 'Dano',
    de: 'Alemany',
    dsb: 'Lower Sorbian',
    dv: 'Divehi',
    el: 'Griyego',
    en: 'Ingles',
    es: 'Espanyol',
    et: 'Estonian',
    eu: 'Basque',
    fa: 'Persiano',
    fi: 'Finnish',
    fil: 'Filipino',
    fj: 'Fijiano',
    fr: 'Pranses',
    frCA: 'Pranses (Kanada)',
    ga: 'Irish',
    gl: 'Galitsiano',
    gom: 'Konkani',
    gu: 'Gujarati',
    ha: 'Hausa',
    he: 'Hebreo',
    hi: 'Hindi',
    hr: 'Kroatiano',
    hsb: 'Upper Sorbian',
    ht: 'Haitian Creole',
    hu: 'Hungarian',
    hy: 'Armenian',
    id: 'Indones',
    ig: 'Igbo',
    ikt: 'Inuinnaqtun',
    is: 'Islendés',
    it: 'Italyano',
    iu: 'Inuktitut',
    iuLatn: 'Inuktitut (Latin)',
    ja: 'Hapones',
    ka: 'Georgiano',
    kk: 'Kazak',
    km: 'Khmer',
    kmr: 'Kurdo (Hilaga)',
    kn: 'Kannada',
    ko: 'Koreano',
    ku: 'Kurdo (Gitnang)',
    ky: 'Kirgiz',
    ln: 'Lingala',
    lo: 'Lao',
    lt: 'Litwan',
    lug: 'Ganda',
    lv: 'Latvian',
    lzh: 'Tsino (Literary)',
    mai: 'Maithili',
    mg: 'Malagasy',
    mi: 'Māori',
    mk: 'Macedonian',
    ml: 'Malayalam',
    mnCyrl: 'Mongolian (Cyrillic)',
    mnMong: 'Mongolian (Tradisyonal)',
    mr: 'Marathi',
    ms: 'Malayo',
    mt: 'Maltese',
    mww: 'Hmong Daw',
    my: 'Myanmar (Burmyo)',
    nb: 'Noruego',
    ne: 'Nepali',
    nl: 'Dutch',
    noSearchLang: 'Wikang hindi sinusuportahan',
    nso: 'Sesotho sa Leboa',
    nya: 'Nyanja',
    or: 'Odia',
    otq: 'Querétaro Otomi',
    pa: 'Punjabi',
    pl: 'Polish',
    placeholder: 'Maghanap',
    prs: 'Dari',
    ps: 'Pashto',
    pt: 'Portuges (Brasil)',
    ptPT: 'Portuges (Portugal)',
    ro: 'Rumano',
    ru: 'Ruso',
    run: 'Rundi',
    rw: 'Kinyarwanda',
    sd: 'Sindhi',
    si: 'Sinhala',
    sk: 'Slovak',
    sl: 'Slovenian',
    sm: 'Samoan',
    sn: 'Shona',
    so: 'Somali',
    sq: 'Albanian',
    srCyrl: 'Serbiano (Cyrillic)',
    srLatn: 'Serbiano (Latin)',
    st: 'Sesotho',
    sv: 'Suedish',
    sw: 'Swahili',
    ta: 'Tamil',
    te: 'Telugu',
    th: 'Thai',
    ti: 'Tigrinya',
    tk: 'Turkmeno',
    tlhLatn: 'Klingon (Latin)',
    tlhPiqd: 'Klingon (pIqaD)',
    tn: 'Setswana',
    to: 'Tongano',
    tr: 'Turko',
    tt: 'Tatar',
    ty: 'Tahitian',
    ug: 'Uyghur',
    uk: 'Ukranyano',
    ur: 'Urdu',
    uz: 'Uzbek (Latin)',
    vi: 'Biyetnam',
    xh: 'Xhosa',
    yo: 'Yoruba',
    yua: 'Yucatec Maya',
    yue: 'Kantones (Tradisyonal)',
    zh: 'Tsino',
    zhHans: 'Simplipikadong Tsino',
    zhHant: 'Tradisyonal na Tsino',
    zu: 'Zulu',
  },
  login: {
    and: 'at',
    btn: 'Mag-log in gamit ang Google',
    btn1: 'Mag-log In Na',
    desc: 'Mag-log in upang ma-unlock ang higit pang mga karanasan',
    policy: 'Patakaran sa Privacy',
    terms: 'Mga Tuntunin sa Paggamit',
    tips: 'Sa pamamagitan ng pag-sign up, sumasang-ayon ako sa',
    title: 'Maligayang pagdating sa Noam',
  },
  pageFooter: {
    follow: { facebook: 'Facebook', title: 'Sumunod', twitter: 'Twitter' },
    legal: { policy: 'Patakaran sa Privacy', terms: 'Mga Tuntunin ng Serbisyo', title: 'Legal' },
    product: {
      image: 'Pagsasalin ng Larawan',
      pdf: 'Pagsasalin ng PDF',
      title: 'Produkto',
      video: 'Pagsasalin at Buod ng Video',
      web: 'Pagsasalin sa Web at Buod',
    },
    resources: { title: 'Mga mapagkukunan' },
    tools: { title: 'Mga Kagamitan', pdf: 'Pagsasalin ng PDF' },
  },
  pageHeader: {
    contact: 'Kontak',
    help: 'Tulong',
    logout: 'Mag-log out',
    logoutSucc: 'Naka-log out na.',
    pricing: 'Presyo',
    settings: 'Mga Setting',
    signUp: 'Mag-login',
  },
  pdf: {
    autoDetect: 'Auto-Detect',
    cancelBtn: 'Kanselahin',
    cancelUpload: 'Kanselahin',
    chatPdf: {
      summaryError: 'Nabigo ang buod, mangyaring subukan muli mamaya',
      chatError: 'Nabigo ang chat, mangyaring subukan muli mamaya',
      Search: 'Maghanap',
      cancel: 'Kanselahin',
      chatTitle: 'Maligayang pagdating sa Noam! Narito ang buod ng iyong PDF:',
      clear: 'Malinaw',
      clearContent:
        'Mag-uumpisa ito ng bagong usapan. Ang kasalukuyang usapan ay hindi maii-save. Sigurado ka ba?',
      clearDialogTitle: 'Pakumpirma',
      clearSucc: 'Nalinis',
      copy: 'Kopyahin',
      copySucc: 'Nakopya',
      delete: 'Tanggalin',
      deleteCancel: 'Kanselahin',
      deleteContent: 'Ang PDF na ito ay hindi mababawi muli kapag na-delete. Sigurado ka ba?',
      deleteOk: 'Tanggalin',
      deleteSuccess: 'Nabura',
      deleteTitle: 'Kumpirmahin ang Pagtanggal',
      expand: 'Bumagsak',
      historyTitle: 'Kasaysayan',
      listError:
        'Nabigong i-load ang listahan ng binabasa. Maaari mong subukan muli sa ibang pagkakataon, o makipag-ugnayan sa suporta.',
      loading: 'Naglo-load...',
      noDataDesc: 'Walang kasaysayan pa.',
      noMore: 'Wala nang karagdagang nilalaman.',
      placeholder: 'Magtanong tungkol sa PDF na ito',
      summaryTitle: 'Maaaring interesado ka sa mga tanong na ito:',
    },
    collectionEmpty: 'Ang iyong koleksyon ay walang laman.',
    collectionTab: 'Mga Tala',
    dataLoading: 'Naglo-load...',
    dialogContent: 'Sigurado ka bang gusto mong tanggalin ito?',
    dialogTitle: 'Pakumpirma',
    download: {
      both: 'Dual-wika',
      btn: 'I-save',
      cancel:
        'Ang pagsasara ng window na ito ay magsasawalang-bisa sa pag-download ng PDF. Sigurado ka bang gusto mong i-cancel ito?',
      desc: 'I-save sa Device: Nagdo-download ng mga pagsasalin bilang mga larawan; I-save at I-print: Nagdo-download ng mga pagsasalin sa orihinal na format, na may suporta sa pagkopya.',
      download: 'I-download',
      downloadMsg1: 'Pag-usad ng Pagsasalin ng PDF:',
      downloadMsg2: 'Tinatayang Natitirang Oras:',
      downloadSucc: 'Handa na ang PDF! I-click upang i-save.',
      downloadTip:
        'Nagdo-download ng PDF. Huwag isara ang window na ito upang maiwasan ang mga error sa pag-download.',
      error: 'Hindi maisave. Subukang mag-print na lamang.',
      fileName: 'Pangalan ng File:',
      fileType: 'Uri ng File:',
      loading: 'Nagsa-save...',
      loading2: 'Naglo-load...',
      minute: 'Mga minuto...',
      msg1: 'Ang ilang mga pagsasalin sa dokumentong ito ay mas mahaba kaysa sa orihinal na teksto, at maaaring mag-overlap sa nai-download na file. Inirerekomenda namin na basahin ito sa webpage.',
      msg2: 'Ang pagsasalin ay hindi pa kumpleto. Mangyaring i-download pagkatapos matapos ang pagsasalin.',
      msg3: '2. Ang ilang pagsasalin ay masyadong mahaba. Basahin sa web page upang maiwasan ang pagkakapatong ng teksto.',
      msg4: 'Ang mga gawain sa pagsasalin ay kasalukuyang isinasagawa. Maaari mong subukan muli pagkatapos nitong matapos.',
      progress:
        'Ninotranslate ang PDF. Pag-usad: {{progress}}, Tinatayang natitirang oras: {{minutes}} minuto...',
      save: 'I-save sa Device',
      savePrint: 'I-save at I-print',
      success: 'Na-download',
      trans: 'Pagsasalin Lamang',
      transContinue: 'Patuloy na Magtranslate',
    },
    downloadBtn: 'I-download',
    dragTipModal: {
      black: 'espasyo',
      leftKey: 'kaliwang pindutan',
      ok: 'Naiintindihan ko',
      press: 'Pindutin',
      tips: 'i-drag at tingnan',
    },
    entry: 'PDFs',
    fileErrMsg:
      'Nabigong basahin ang file. Maaari mong subukang muli sa ibang pagkakataon, o makipag-ugnayan sa suporta.',
    fileMsg: 'Kasalukuyang laki ng file:',
    fileMsg2: 'Mangyaring mag-upload ng isang file na mas maliit sa 300MB.',
    freeBannerBtn: 'I-upgrade',
    freeBannerTips: 'Naabot na ang Limitasyon ng Libreng Pagsasalin ng PDF',
    guide: {
      placeholder: 'Ikolokya ang link ng PDF dito',
      start: 'Simulan ang Pagsasalin',
      text1: 'Bilinggwal na Pagbabasa',
      text2:
        'Magbasa nang bilinggwal upang maihambing ang orihinal na teksto at pagsasalin nang magkatabi, na nagpapabuti sa iyong kahusayan.',
      text3: 'Makipag-usap sa Iyong PDF',
      text4:
        'Pagsusuri at pagbuod na pinapagana ng AI. Magtanong tungkol sa iyong PDF, at makakuha ng agarang sagot.',
      text5: 'Tumpak at Epektibo',
      text6: 'AI-powered na pagsasalin ng PDF para sa mas mataas na katumpakan at kahusayan.',
      title1: 'Dual-wika na Pagsasalin',
      title2: 'Makipag-usap sa Iyong PDF',
      toast: 'Mangyaring maglagay ng wastong online na PDF link na nagtatapos sa .pdf',
    },
    hasTransTask: 'Isinasagawa ang isang gawain sa pagsasalin. Mangyaring maghintay.',
    hoverTrans: 'I-hover upang Isalin ang Mga Parapo',
    initial: 'Isalin ang PDF',
    installText: 'Ang iyong one-stop solusyon para sa pang-araw-araw na pagsasalin.',
    installText2: 'Mangyaring i-install muna ang extension',
    installTips:
      'I-install ang extension para sa higit pang mga pagsasalin ng PDF, at mas maayos na pagsasalin ng website:',
    kw: 'pako de stapler',
    link: 'link',
    listError:
      'Nabigong mag-load ng mga PDF. Maaari mong subukang muli sa ibang pagkakataon, o makipag-ugnayan sa suporta.',
    memoTotalCount: '1 item ang kabuuan',
    new: 'bagong file',
    noId: 'Hindi natagpuan ang File ID.',
    notPdf: 'Mga PDF file lamang.',
    okBtn: 'Tanggalin',
    okBtn2: 'Naiintindihan ko',
    original:
      'Ikaw ay isang napakatumpak at mapagkakatiwalaang AI na idinisenyo upang bumuo ng output na JSON na eksaktoong sumusunod sa isang tinukoy na JSON Schema.\n        \nDapat mong sundin ang mga patakarang ito:\n1. Mahigpit na sumunod sa istraktura ng JSON Schema.\n2. Eksaktoong tumugma sa lahat ng uri ng data, kinakailangang mga field, at mga hadlang.\n3. HUWAG maglagay ng anumang karagdagang teksto, paliwanag, markdown, o mga komento.\n4. I-output LAMANG ang object na JSON — walang mga code block, walang paunang salita, walang pagbabalot.\n\nAng impormasyon ng schema ay ibinibigay sa ibaba.\n- Pangalan ng Schema: translate_result\n- JSON Schema:\n{"type":"object","properties":{"sourceLang":{"type":"string"},"source":{"type":"string"},"targetLang":{"type":"string"},"target":{"type":"string"}},"required":["sourceLang","source","targetLang","target"],"additionalProperties":false}',
    parallel: 'Paralelo',
    parseErrDialogContent:
      'Ang link ng PDF na ito ay hindi direktang maisasalin. Mangyaring i-download ang PDF at i-upload ito para sa pagsasalin.',
    parseErrTips: 'Nabigong i-parse ang file',
    parseFileToast:
      'Nabigong mag-parse ng file. Maaari mong subukang muli sa ibang pagkakataon, o makipag-ugnayan sa suporta.',
    pdfLoading: 'Nagpaparsang...',
    searchPlaceholder: 'Hanapin',
    selectTrans: 'Piliin ang Teksto upang Isalin',
    shareBtn: 'Ibahagi',
    shareBtnText1: 'Bumuo ng Link para Ibahagi',
    shareBtnText2: 'I-update ang Ibinahaging Nilalaman',
    shareModal: {
      cancel: 'Kanselahin',
      copy: 'Kopyahin',
      copySucc: 'Nakopya ang Link',
      custom: 'I-customize:',
      errMsg:
        'Ang napiling nilalaman ay hindi pa ganap na naisasalin. Mangyaring isalin muna bago ibahagi.',
      gen: 'Ibahagi',
      modify: 'I-edit',
      notSupport: 'Ang wikang ito ay hindi kasalukuyang sinusuportahan.',
      page: 'Mga Pahina',
      pageNuErr: 'Mangyaring mag-input ng wastong numero ng pahina.',
      range: ' saklaw:',
      remain: 'natitira',
      remain1: 'Tatayong oras ng pagtatantya:',
      search: 'Maghanap',
      settings: 'Mga Setting sa Pagbabahagi:',
      shareSetting: 'Mga Setting sa Pagbabahagi',
      shareText: 'Ibahagi',
      shareTips: 'Ibahagi ang link ng nai-translate na PDF sa iyong mga kaibigan:',
      sourceLang: 'Mula sa:',
      target: 'Para sa:',
      text1: 'Mga Setting ng Pagbabahagi',
      text2: 'Bumuo ng Link para Ibahagi',
      totalPage: '1 pahina lahat',
      trans: 'Isalin',
      translateTips:
        'Tip: Kung matagal ang pagsasalin, maaari mong isara ang window na ito at ibahagi sa ibang pagkakataon.',
      translating: 'Ninotranslate ang PDF...',
      update: 'I-update ang Share Link',
    },
    shareMsg1: 'Nagawa ang link para sa pagbabahagi.',
    shareMsg2: 'Nauupdate ang ibinahaging nilalaman.',
    shareMsg3:
      'Nabigong bumuo ng link para ibahagi. Maaari mong subukang muli sa ibang pagkakataon, o makipag-ugnayan sa suporta.',
    shareMsg4:
      'Nabigong i-update ang ibinahaging nilalaman. Maaari mong subukang muli mamaya, o makipag-ugnayan sa suporta.',
    shareTips: 'Handa na ang iyong PDF na nai-translate! Ibahagi ito sa iyong mga kaibigan.',
    start: 'Simulan ang Iyong Libreng Pagsubok',
    thumbnail: 'Talaan ng Nilalaman',
    toast1: 'Naglo-load ng PDF. Maaari mong subukang muli mamaya.',
    toast2: 'Ang nilalaman ng PDF ay pinoproseso. Ang dialog ay kasalukuyang hindi sinusuportahan.',
    toast3: 'Nagdo-download. Maaari mong subukan muli pagkatapos matapos ang pag-download.',
    toolbar: { Adjust: 'Ayusin', autoFit: 'Auto-angkop' },
    trans: 'Pagsasalin',
    transSucc: 'Matagumpay ang pagsasalin!',
    unLoginToast: 'Mangyaring mag-log in upang gamitin ang tampok na ito.',
    uploadBtn: 'I-upload',
    uploadErr:
      'Nabigo ang pag-upload ng file. Maaari mong subukang muli sa ibang pagkakataon, o makipag-ugnayan sa suporta.',
    uploadErrSignUrl:
      'Nabigo sa pagkuha ng URL para sa pag-upload. Maaari mong subukan muli mamaya, o makipag-ugnayan sa suporta.',
    uploadMsg1: 'I-drag at i-drop ang iyong file dito.',
    uploadMsg2: 'Mga Sinusuportahang Uri ng File: PDF  |  Maximum na Laki ng File: 300MB',
    uploadMsg3: 'I-click upang piliin o i-drag at i-drop ang mga file dito.',
    uploading: 'Nag-uupload',
    uploadingMsg: 'Nag-uupload. Mangyaring maghintay.',
    uploadingMsg1:
      'Ang file ay sinusubukang mai-upload. Mangyaring subukan muli sa ibang pagkakataon.',
    uploadingMsg2:
      'Isinasagawa ang conversion ng isang file sa kasalukuyan. Magsubok muli sa ibang pagkakataon.',
    uploadingMsg3:
      'Nabigo ang kahilingan para sa pag-unlad ng conversion. Mangyaring subukan muli mamaya, o makipag-ugnayan sa suporta.',
    uploadingMsg4:
      'Hindi ma-access ni Noam ang mga lokal na file. Mangyaring manu-manong mag-upload ng PDF para sa pagsasalin.',
    uploadingMsg5:
      'Nabigo sa pagkuha ng URL ng file. Maaari mong subukang muli mamaya, o makipag-ugnayan sa suporta.',
    video: 'video',
    vipBannerBtn: 'I-upgrade',
    vipBannerTips: 'Naabot mo na ang iyong limitasyon sa pagsasalin ng PDF para sa buwang ito.',
    webTrans: 'Pantay na Cross-Reference',
  },
  pricing: {
    FAQ: 'MGA KARANIWANG TANONG',
    FQAObj: {
      a1: 'Oo, nag-aalok si Noam ng libreng plano na magagamit mo kaagad.',
      a2: 'Nag-aalok kami ng tatlong plano ng miyembro: Pro, Pro+, at Enterprise. Maaari kang pumili na magbayad buwan-buwan o taun-taon. Ang taunang pagsingil ay nag-aalok ng malaking pagtitipid.',
      a3: 'Lahat ng tampok ay magagamit sa parehong mga plano. Ang pangunahing pagkakaiba ay ang halaga: ang mga taunang subscription ay mas mura sa pangkalahatan. Ang mga buwanang subscription ay sinisingil bawat buwan, habang ang mga taunang plano ay sinisingil isang beses bawat taon.',
      a4: 'Maaari mong kanselahin ang iyong subscription anumang oras sa iyong Mga Setting ng Account.',
      q1: 'Mayroon bang libreng plano?',
      q2: 'Ano ang mga available na pricing plan at payment option?',
      q3: 'Ano ang pagkakaiba sa pag-subscribe ng buwan-buwan kumpara sa taun-taon?',
      q4: 'Paano ko icancel ang aking subscription?',
    },
    around: 'Sa paligid ng',
    billedMonthly: 'Nabibiling Buwanan',
    billedYearly: 'Sinisingil Taun-taon',
    day: 'araw',
    desc: 'Ihambing ang mga Plano at Piliin ang Pinakamahusay',
    detailedCompare: 'Ihambing ang mga Plano',
    discount: '20% Discount',
    enterprise: {
      benefit1: 'Pangunahing Suporta sa Kustomer',
      benefit2: 'Maramihang Mga User',
      benefit3: 'Mga Nakaakma na Solusyon',
      benefit5: 'Dedicated na Account Manager',
      btn: 'Kontakin Kami',
      recommendText: 'Mga Custom na Plano (≥3 tao)',
      talkToUs: 'Makipag-ugnayan',
    },
    free: {
      benefit1: 'Instant na pagsasalin 100 beses/araw',
      benefit2: 'Pagsasalin at Buod ng Website',
      benefit3: '30 Translations ng Larawan',
      benefit4: 'Pagsasalin at Buod ng Video',
      benefit5: '10 PDF na Pagsasalin',
      benefit6: '5,000 token',
      btn: 'Subukan nang Libre',
      recommendText: 'Libreng Pagsubok',
    },
    imageTranslation: 'Pagsasalin ng Larawan',
    month: 'buwan',
    monthly: 'Buwanang',
    pageTitle: 'Presyo',
    pdf: {
      chat: 'Mga Katanungan sa Chat ng PDF',
      maxPage: 'Max. Pahina bawat PDF',
      translation: 'Pagsasalin ng PDF',
    },
    preMonth: 'Bawat buwan',
    pro: {
      benefit1: 'Pangunahing Suporta sa Mamimili',
      benefit2: '1,000,000 token kada buwan',
      benefit3: 'Pagsasalin at Buod ng Website',
      benefit4: '200 Translations ng Larawan',
      benefit5: 'Pagsasalin at Buod ng Video',
      benefit6: '200 PDF na Pagsasalin',
      btn: 'Simulan',
      recommendText: 'Pinakasikat',
    },
    proPlus: {
      benefit1: 'Prayoridad na Suporta sa Mamimili',
      benefit2: '3,000,000 token kada buwan',
      benefit3: 'Pagsasalin at Buod ng Website',
      benefit4: '500 Mga Pagsasalin ng Larawan',
      benefit5: 'Pagsasalin at Buod ng Video',
      benefit6: '500 mga Pagsasalin ng PDF',
      recommendText: 'Pinakamahusay na Halaga',
    },
    video: { summary: 'Buod ng Video', translation: 'Pagsasalin ng Bidyo' },
    web: {
      contrastiveTranslation: 'Dual-wika na Pagsasalin',
      dictionaryTranslation: 'Pagpili ng Pagsasalin',
      hoverTranslation: 'Pagsasalin sa Hover',
      instantTranslation: 'Agad na Pagsasalin',
      summary: 'Buod ng Web Page',
    },
    yearly: 'Taun-taon',
  },
  privacy: {
    block1:
      'Iginagalang ng Noam ("Noam," "kami," "aming," o "sa amin") ang iyong privacy at nangangako na protektahan ang anumang impormasyong nakukuha namin mula sa iyo o tungkol sa iyo. Inilalarawan ng Patakaran sa Privacy na ito ang aming mga kasanayan tungkol sa pagkolekta o paggamit ng personal na impormasyon mula sa iyong paggamit ng aming website, mga aplikasyon, at serbisyo (pinagsama-samang tinatawag na "Mga Serbisyo"). Hindi nalalapat ang Patakaran sa Privacy na ito sa nilalaman na hinahawakan namin sa ngalan ng aming mga customer ng produktong pangnegosyo, tulad ng aming API. Ang paggamit ng data na ito ay napapailalim sa aming kasunduan sa customer, na sumasaklaw sa pag-access at paggamit ng mga produktong ito.',
    block10:
      "Nagpapatupad kami ng mga teknikal, administratibo, at organisasyonal na hakbang na makatwiran sa komersyo upang protektahan ang personal na impormasyon online at offline mula sa pagkawala, maling paggamit, at hindi awtorisadong pag-access, pagsisiwalat, pagbabago, o mga pagalit na aksyon. Gayunpaman, walang transmisyon sa internet o email ang maaaring garantiyahan ang ganap na seguridad o katumpakan. Lalo na, ang mga email na ipinapadala sa amin o mula sa amin ay maaaring hindi ligtas. Kaya, dapat kang maging partikular na maingat kapag nagpapasya kung anong impormasyon ang ipapadala sa amin sa pamamagitan ng serbisyo o email. Bukod pa rito, hindi kami responsable para sa anumang pagharang ng mga setting sa privacy o mga hakbang sa seguridad sa serbisyo o mga setting sa seguridad o mga hakbang sa seguridad ng Mga Ikatlong Partido na Website. Pananatilihin namin ang iyong personal na impormasyon hangga't kinakailangan para sa amin na magbigay sa iyo ng mga serbisyo o para sa iba pang mga lehitimong layunin sa negosyo, tulad ng paglutas ng mga pagtatalo, mga kadahilanan sa seguridad at kaligtasan, o pagsunod sa aming mga legal na obligasyon. Ang haba ng panahon na pinananatili namin ang personal na impormasyon ay depende sa maraming mga kadahilanan, tulad ng dami, kalikasan, sensitivity ng impormasyon, ang mga potensyal na panganib ng hindi awtorisadong paggamit o pagsisiwalat, ang mga layunin kung saan namin pinoproseso ang impormasyon, at iba pang mga legal na nagbibigkis na pagsasaalang-alang.",
    block11:
      'Maaari naming i-update ang Patakaran sa Privacy na ito paminsan-minsan. Kapag ginawa namin ito, ipapaskil namin ang isang na-update na bersyon sa pahinang ito, maliban kung iba ang kinakailangan ng naaangkop na batas.',
    block12:
      'Kung mayroon kang anumang hindi nasagot na mga tanong o alalahanin tungkol sa Patakarang Pangkaprivacyang ito, mangyaring makipag-ugnayan sa aming serbisyo sa customer. Email:',
    block2:
      'Nakokolekta namin ang sumusunod na personal na impormasyon ("Personal na Impormasyon") na nauugnay sa iyo:',
    block3:
      'Impormasyong Ibinigay Mo: Kapag gumawa ka ng account upang gamitin ang aming mga serbisyo o makipag-usap sa amin, kinokolekta namin ang personal na impormasyon gaya ng sumusunod:',
    block4:
      'Personal na Impormasyong AwtoMatikong Natatanggap Mula sa Iyong Paggamit ng Mga Serbisyo: Kapag ka ay nag-a-access, gumagamit, o nakikipag-ugnayan sa mga serbisyo, tumatanggap kami ng sumusunod na impormasyon tungkol sa iyong pag-access, paggamit, o pakikipag-ugnayan ("Teknikal na Impormasyon"):',
    block5: 'Maaari naming gamitin ang personal na impormasyon para sa mga sumusunod na layunin:',
    block6:
      'Buod o Hindi Nakikilalang Impormasyon: Maaari naming pagsama-samahin o alisin ang pagkakakilanlan ng personal na impormasyon upang maiwasan ang muling paggamit nito para sa mga layuning pagkakakilanlan at gamitin ang naturang impormasyon upang suriin ang bisa ng aming mga serbisyo, pagbutihin at magdagdag ng mga tampok sa aming mga serbisyo, magsagawa ng pananaliksik, at para sa mga katulad na layunin. Bukod dito, maaari naming suriin ang pangkalahatang pag-uugali at mga katangian ng mga gumagamit ng aming serbisyo at ibahagi ang pinagsama-samang impormasyon sa mga third party, ipublish ang naturang pinagsama-samang impormasyon, o gawing available ito sa pangkalahatan. Maaari naming kolektahin ang pinagsama-samang impormasyon sa pamamagitan ng mga serbisyo, sa pamamagitan ng mga cookie, at sa pamamagitan ng iba pang paraan na inilarawan sa Patakaran sa Privacy na ito. Pananatilihin at gagamitin namin ang hindi nakikilalang impormasyon sa isang anonymous o hindi nakikilalang anyo, at hindi namin tatangkain na muling kilalanin ang naturang impormasyon maliban kung kinakailangan ng batas.',
    block7:
      'Sa ilang mga kaso, maaari naming ibigay ang iyong personal na impormasyon sa mga third party nang walang karagdagang abiso sa iyo, maliban kung kinakailangan ng batas:',
    block8:
      'Depende sa iyong lokasyong heograpikal, ang mga indibidwal sa European Economic Area, United Kingdom, at sa buong mundo ay maaaring may mga tiyak na legal na karapatan tungkol sa kanilang personal na impormasyon. Halimbawa, maaari kang magkaroon ng karapatang:',
    block9:
      'Ang serbisyo ay maaaring maglaman ng mga link patungo sa ibang mga website na hindi pinamamahalaan o kinokontrol ng Noam, kabilang ang mga serbisyo sa social media ("Mga Website ng Ikatlong Partido"). Ang impormasyong ibinabahagi mo sa Mga Website ng Ikatlong Partido ay susundin ng mga partikular na patakaran sa privacy at tuntunin ng serbisyo ng Mga Website ng Ikatlong Partido, hindi ng Patakarang ito sa Privacy. Nagbibigay kami ng mga link na ito para sa kaginhawahan at hindi nangangahulugan ng aming pag-endorso o pagsusuri sa mga website na ito. Mangyaring makipag-ugnayan direktamente sa Mga Website ng Ikatlong Partido para sa impormasyon tungkol sa kanilang mga patakaran sa privacy at tuntunin.',
    subBlock1:
      'Impormasyon sa Account: Kapag gumawa ka ng account sa aming platform, kinokolekta namin ang impormasyong nauugnay sa iyong account, kabilang ang iyong pangalan, impormasyong pangkontak, mga kredensyal ng account, impormasyon sa kard ng pagbabayad, at kasaysayan ng transaksyon ("Impormasyon sa Account").',
    subBlock10: 'Pagbibigay, pamamahala, pagpapanatili, at/o pagsusuri ng mga serbisyo;',
    subBlock11: 'Pakikipag-usap sa iyo',
    subBlock12: 'Pagbuo ng mga bagong produkto at serbisyo;',
    subBlock13:
      'Pagpigil sa pandaraya, kriminal na aktibidad, o maling paggamit ng aming mga serbisyo, at pagprotekta sa seguridad ng aming mga IT system, arkitektura, at network;',
    subBlock14: 'Pagsasagawa ng mga paglilipat ng negosyo;',
    subBlock15:
      'Pagsunod sa mga legal na obligasyon at prosesong legal, pagprotekta sa aming mga karapatan, privacy, seguridad, o ari-arian, pati na rin ang mga nito ng aming mga kaakibat, ikaw, o iba pang mga third party.',
    subBlock16:
      'Mga Supplier at Tagapagbigay ng Serbisyo: Upang matulungan kaming matugunan ang mga pangangailangan sa operasyon ng negosyo at maisagawa ang ilang mga serbisyo at tungkulin, maaari naming ibigay ang personal na impormasyon sa mga supplier at tagapagbigay ng serbisyo, kabilang ang mga tagapagbigay ng hosting service, cloud service providers, at iba pang mga tagapagbigay ng serbisyo sa teknolohiyang impormasyon, software para sa komunikasyong email, at mga tagapagbigay ng serbisyo sa web analytics, atbp. Ang mga kasamang ito ay makakakuha, magpoproseso, o mag-iimbak lamang ng personal na impormasyon sa aming direksyon habang nagsasagawa sila ng kanilang mga tungkulin para sa amin.',
    subBlock17:
      'Paglipat ng Negosyo: Kung makikibahagi kami sa mga estratehikong transaksyon, reorganisasyon, bangkarota, pagkuha ng bangkarota, o paglipat ng serbisyo sa ibang provider (pinagsama-samang tinatawag na "Mga Transaksyon"), ang iyong personal na impormasyon at iba pang impormasyon ay maaaring ibahagi sa mga katapat na transaksyon at iba pang partido na tumutulong sa Mga Transaksyon sa panahon ng due diligence at ililipat bilang bahagi ng Mga Transaksyon kasama ang iba pang mga ari-arian sa isang kahaliling kumpanya o kaakibat na kumpanya.',
    subBlock18:
      'Mga Legal na Kinakailangan: Maaari naming ibahagi ang iyong personal na impormasyon sa mga awtoridad ng gobyerno, mga kapwa sa industriya, o iba pang mga third party, kabilang ang impormasyon tungkol sa iyong pakikipag-ugnayan sa aming mga serbisyo, (1) kung kinakailangan ng batas o kung naniniwala kami na ang naturang aksyon ay kinakailangan upang sumunod sa mga legal na obligasyon; (2) upang protektahan at ipagtanggol ang aming mga karapatan o ari-arian; (3) kung aming pasalungat na natukoy na mayroong paglabag sa aming mga tuntunin, patakaran, o mga batas; (4) upang makita o maiwasan ang pandaraya o iba pang mga ilegal na aktibidad; (5) upang protektahan ang aming mga produkto, mga empleyado, o mga user, o kaligtasan ng publiko, seguridad, integridad; o (vi) upang ipagtanggol laban sa legal na pananagutan.',
    subBlock19:
      'I-access ang iyong personal na impormasyon at impormasyon tungkol sa kung paano ito pinoproseso.',
    subBlock2:
      'Kapag gumamit ka ng aming mga serbisyo, kinokolekta namin ang personal na impormasyon mula sa iyong mga input, pag-upload ng file, o feedback na ibinigay sa amin ("Content").',
    subBlock20: 'Humingi ng pagtanggal ng iyong personal na impormasyon mula sa aming mga talaan.',
    subBlock21: 'Itama o i-update ang iyong personal na impormasyon.',
    subBlock22:
      'Ilipat ang iyong personal na impormasyon sa isang third party (portabilidad ng data).',
    subBlock23: 'Limitahan kung paano namin iproseso ang iyong personal na impormasyon.',
    subBlock24:
      'Bawiin ang iyong pahintulot—kung umaasa kami sa pahintulot bilang legal na batayan para sa pagproseso, maaari mong bawiin ang iyong pahintulot anumang oras.',
    subBlock25:
      'Magreklamo tungkol sa kung paano namin pinoproseso ang iyong personal na impormasyon.',
    subBlock26: 'Pagpapabuti ng aming mga serbisyo at pagsasagawa ng pananaliksik;',
    subBlock3:
      'Impormasyong Pangkomunikasyon: Kung magpapadala ka sa amin ng mga mensahe, kami ay mangongolekta ng iyong pangalan, impormasyong pangkontak, at nilalaman ng iyong mga mensahe ("Impormasyong Pangkomunikasyon").',
    subBlock4:
      'Impormasyon sa Social Media: Mayroon kaming mga pahina sa mga website ng social media tulad ng Instagram, Facebook, Medium, Twitter, YouTube, at LinkedIn. Kapag nakikipag-ugnayan ka sa aming mga pahina sa social media, kinokolekta namin ang personal na impormasyon na pinili mong ibigay sa amin, tulad ng iyong mga detalye sa pakikipag-ugnayan ("Impormasyong Panlipunan"). Bukod pa rito, ang mga kumpanyang nagho-host ng aming mga pahina sa social media ay maaaring magbigay sa amin ng pinagsama-samang impormasyon at pagsusuri tungkol sa aming mga aktibidad sa social media.',
    subBlock5:
      'Data ng Log: Impormasyong awtomatikong ipinapadala ng iyong browser kapag gumagamit ng aming mga serbisyo. Kasama sa data ng log ang iyong Internet Protocol (IP) address, uri at mga setting ng browser, petsa at oras ng iyong mga kahilingan, at kung paano ka nakikipag-ugnayan sa aming website.',
    subBlock6:
      'Datum ng Paggamit: Maaari naming awtomatikong kolektahin ang impormasyon tungkol sa iyong paggamit ng serbisyo, tulad ng mga uri ng nilalaman na iyong tinitingnan o nakikipag-ugnayan, ang mga tampok na iyong ginagamit, ang mga aksyong iyong ginagawa, pati na rin ang iyong time zone, bansa, petsa at oras ng pag-access, user agent at bersyon, uri ng computer o mobile device, at ang iyong koneksyon sa computer.',
    subBlock7:
      'Impormasyon sa Device: Kasama rito ang pangalan ng device, operating system, device identifier, at ang browser na iyong ginagamit. Ang impormasyong nakokolekta ay maaaring depende sa uri ng device na iyong ginagamit at mga setting nito.',
    subBlock8:
      'Mga Cookie: Gumagamit kami ng mga cookie upang mapatakbo at pamahalaan ang aming mga serbisyo at mapabuti ang iyong karanasan. Ang "cookie" ay impormasyong ipinapadala ng isang website na iyong binibisita sa iyong browser. Maaari mong itakda ang iyong browser upang tanggapin ang lahat ng cookie, tanggihan ang lahat ng cookie, o ipaalam sa iyo kapag may ibinigay na cookie upang maaari mong magpasya kung tatanggapin mo ito sa bawat pagkakataon. Gayunpaman, ang pagtanggi sa mga cookie ay maaaring hadlangan kang gamitin o negatibong makaapekto sa pagpapakita o paggana ng ilang partikular na lugar o tampok ng website. Para sa karagdagang impormasyon tungkol sa mga cookie, mangyaring bisitahin ang All About Cookies.',
    subBlock9:
      "Analytics: Maaari kaming gumamit ng iba't ibang online analytics na produkto na gumagamit ng mga cookie upang matulungan kaming pag-aralan kung paano ginagamit ng mga user ang aming mga serbisyo at mapabuti ang iyong karanasan kapag gumagamit ng mga serbisyo.",
    subTitle1: 'Personal na Impormasyong Kinokolekta Namin',
    subTitle2: 'Paano Namin Ginagamit ang Personal na Impormasyon',
    subTitle3: 'Pagsisiwalat ng Personal na Impormasyon',
    subTitle4: 'Mga Karapatan Mo',
    subTitle5: 'Mga Link patungo sa Iba pang Mga Website',
    subTitle6: 'Seguridad at Pagpapanatili ng Impormasyon',
    subTitle7: 'Pagbabago sa Patakaran sa Privacy',
    subTitle8: 'Paano Kang Makikipag-ugnayan sa Amin',
    title: 'Patakaran sa Privacy',
    updateTime: 'Na-update: Marso 15, 2024',
  },
  privacyCollectionPanel: {
    acceptBtn: 'Tanggapin Lahat',
    text: 'Upang mapabuti ang iyong karanasan, gumagamit kami ng mga cookie upang i-personalize ang nilalaman at mga serbisyo.',
    title: 'Gumagamit ang website na ito ng mga cookie',
  },
  slogen: 'Ang pinakasimple na AI assistant',
  stripe: {
    contact: 'Makipag-ugnayan sa amin sa contact@noam.tools kung mayroon kang anumang mga tanong!',
    fail: {
      btn: 'Subukan muli',
      text1: 'Hindi namin maiproseso ang iyong pagbabayad.',
      text2: 'Suriin ang iyong koneksyon at subukang muli.',
      title: 'Nabigo ang pagbabayad',
    },
    succ: {
      btn: 'Tara na',
      text1: 'Maligayang pagdating sa Noam',
      text2: 'simulan na natin!',
      title: 'Binabati kita',
    },
  },
  terms: {
    block1: 'Salamat sa paggamit ng Noam!',
    block10:
      '(a) Mga Bayad at Pagsingil. Magbabayad ka ng lahat ng mga bayad ("Mga Bayad") alinsunod sa presyo at mga tuntunin sa naaangkop na pahina ng presyo o gaya ng napagkasunduan sa nakasulat sa pagitan natin. Nagpapanatili kami ng karapatan na itama ang mga error o pagkakamali sa presyo kahit na nag-issue na kami ng mga invoice o nakatanggap na ng bayad. Magbibigay ka ng kumpleto at tumpak na impormasyon sa pagsingil, kabilang ang isang wasto at awtorisadong paraan ng pagbabayad. Susingilin namin ang iyong paraan ng pagbabayad sa isang regular na batayan gaya ng napagkasunduan, ngunit maaari naming makatwirang baguhin ang petsa ng pagsingil. Inaawtorisahan mo ang Noam, ang mga kaakibat nito, at mga third-party na tagapagproseso ng pagbabayad na singilin ang iyong paraan ng pagbabayad. Kung nabigo ang iyong pagbabayad, magbibigay kami sa iyo ng nakasulat na abiso at maaaring suspindihin ang access sa Serbisyo hanggang sa matanggap ang bayad. Maliban kung iba ang tinukoy sa kasunduang ito, ang mga bayad ay hindi mababalik.',
    block11:
      '(b) Buwis. Maliban kung nakasaad, ang mga Bayad ay hindi kasama ang anumang pederal, estado, lokal, at dayuhang buwis, tungkulin, at mga katulad na pagtatasa ("Mga Buwis"). Ikaw ang responsable para sa lahat ng Mga Buwis na nauugnay sa iyong mga pagbili, maliban sa Mga Buwis na batay sa aming netong kita kung saan kami ay mag-iinvoice sa iyo. Sumasang-ayon ka na agad na bayaran ang naturang Mga Buwis at magbigay sa amin ng mga legal na wastong pahayag ng privacy at kumuha ng mga kinakailangang pahintulot para sa paghawak ng naturang data, at ginagarantiya mo sa amin na hawak mo ang naturang data alinsunod sa naaangkop na batas.',
    block12:
      '(c) Pagbabago ng Presyo. Maaari naming baguhin ang aming mga presyo sa pamamagitan ng pagbibigay ng abiso sa iyo sa pamamagitan ng iyong account at/o aming website. Ang mga pagtaas ng presyo ay magkakabisa kaagad pagkatapos mai-post. Ang anumang pagbabago sa presyo ay magkakabisa sa mga Bayarin para sa iyong account pagkatapos ng petsa ng bisa ng pagbabago.',
    block13:
      '(d) Pagtatalo at mga Napakahabang Panahong Pagbabayad. Kung nais mong ipatawaran ang anumang Mga Bayarin o Buwis, mangyaring makipag-ugnayan sa contact@noam.tools sa loob ng tatlumpung (30) araw mula sa petsa ng invoice.',
    block14:
      '(e) Libreng Paggamit. Hindi ka maaaring lumikha ng maraming mga account upang makakuha ng libreng kredito. Kung matukoy namin na hindi ka gumagamit ng libreng kredito nang may mabuting hangarin, maaari ka naming singilin ng mga karaniwang bayad o ihinto ang pagbibigay ng access sa Serbisyo.',
    block15:
      "(a) Pagkakakonfidensyal. Maaari kang magkaroon ng access sa confidential na impormasyon ng Noam. Maaari mo lamang gamitin ang confidential na impormasyon gaya ng pinahihintulutan ng mga tuntuning ito para sa layunin ng paggamit ng Serbisyo. Hindi mo dapat ibunyag ang confidential na impormasyon sa sinumang third party, at dapat mong protektahan ang confidential na impormasyon sa paraang hindi mas mababa ang proteksyon kaysa sa pagprotekta mo sa iyong sariling katulad na confidential na impormasyon, hindi bababa sa may makatwirang pag-iingat. Ang confidential na impormasyon ay di-publiko na impormasyong itinalaga bilang confidential ng Noam o dapat makatwirang tratuhin bilang confidential sa mga pangyayari, kabilang ang software, mga detalye, at iba pang di-publiko na impormasyong pangnegosyo. Hindi kasama sa confidential na impormasyon ang impormasyong: (1) naging pangkalahatang available sa publiko nang walang kasalanan sa iyong bahagi; (2) nasa iyong pag-aari nang walang anumang obligasyon ng confidentiality bago mo ito natanggap sa ilalim ng mga tuntuning ito; (3) legal na ibinunyag sa iyo ng isang third party nang walang anumang obligasyon ng confidentiality; o (4) independiyenteng binuo mo nang hindi ginagamit ang confidential na impormasyon. Maaari mong ibunyag ang confidential na impormasyon kung kinakailangan ng batas, korte, o iba pang utos ng gobyerno, ngunit dapat mong ibigay ang paunang nakasulat na abiso sa Noam sa makatwirang paraan at, hangga't maaari, gumawa ng makatwirang pagsisikap upang limitahan ang saklaw ng pagbubunyag, kabilang ang pagtulong sa amin sa pagtutol sa mga kahilingan sa pagbubunyag.",
    block16:
      '(b) Seguridad. Dapat kang magpatupad ng makatuwiran at naaangkop na mga hakbang upang tumulong na maprotektahan ang iyong pag-access sa at paggamit ng Serbisyo. Kung makakita ka ng anumang mga kahinaan o paglabag na may kaugnayan sa iyong paggamit ng Serbisyo, dapat mong agad na makipag-ugnayan kay Noam at ibigay ang mga detalye ng kahinaan o paglabag.',
    block17:
      '((c) Pagproseso ng Personal na Data. Kung gagamit ka ng Serbisyo upang magproseso ng personal na data, dapat kang magbigay ng mga legal na sapat na pahayag sa privacy at kumuha ng mga kinakailangang pahintulot para sa pagproseso ng naturang data, at ginagarantiya mo sa amin na hinahandle mo ang naturang data alinsunod sa naaangkop na batas.',
    block18:
      '(a) Pagwawakas; Pansamantalang Pagsuspinde. Ang mga tuntuning ito ay magkakabisa mula sa iyong unang paggamit ng Serbisyo at mananatiling may bisa hanggang sa matapos. Maaari mong wakasan ang mga tuntuning ito anumang oras para sa anumang dahilan sa pamamagitan ng pagtigil sa paggamit ng Serbisyo at nilalaman. Maaari naming wakasan ang mga tuntuning ito nang may paunang abiso para sa anumang dahilan. Maaari naming agad na wakasan ang mga tuntuning ito sa pamamagitan ng pagbibigay ng abiso sa iyo kung ikaw ay materyal na lumabag sa Seksyon 2 (Mga Kinakailangan sa Paggamit), Seksyon 5 (Pagkakakonfidensyal, Seguridad, at Proteksyon ng Data), Seksyon 8 (Paglutas ng Dispute), o Seksyon 9 (Mga Pangkalahatang Tuntunin), o kung ang aming relasyon sa sinumang third-party technology provider na lampas sa aming kontrol ay nagbago, o para sa pagsunod sa batas o mga kahilingan ng gobyerno. Maaari naming suspindihin ang iyong access sa Serbisyo kung hindi ka sumunod sa mga tuntuning ito, o kung ang iyong paggamit ay nagdudulot ng panganib sa seguridad sa amin o sa sinumang third party, o kung may hinala kaming ang iyong paggamit ay pandaraya o maaaring maglantad sa amin o sa sinumang third party sa pananagutan.',
    block19:
      '(b) Mga Epekto ng Pagwawakas. Sa pagwawakas, titigil ka sa paggamit ng Serbisyo at agad na ibabalik o sisirain ang anumang kumpidensyal na impormasyon ayon sa aming tagubilin. Ang mga probisyon ng mga tuntuning ito na sa kanilang likas na katangian ay dapat manatili pagkatapos ng pagwawakas o pag-expire, kabilang ngunit hindi limitado sa mga Seksyon 3 at 5-9, ay mananatili.',
    block2:
      'Ang Mga Tuntunin ng Paggamit na ito ay nalalapat sa iyong paggamit ng mga serbisyo ni Noam, kabilang ang aming mga application programming interface, software, tool, serbisyo para sa developer, data, dokumentasyon, at website (pinagsama-samang tinutukoy bilang "Mga Serbisyo"). Sa pamamagitan ng paggamit ng aming Mga Serbisyo, sumasang-ayon ka na sundin ang mga tuntuning ito. Ipinapaliwanag ng aming Patakaran sa Privacy kung paano namin kinokolekta at ginagamit ang personal na impormasyon.',
    block20:
      'Kompensasyon. Dapat mong ipagtanggol, babayaran, at panatilihing walang pananagutan ang amin, ang aming mga kaakibat, at ang aming mga tauhan mula sa anumang mga claim, pagkalugi, at gastos (kasama ang mga bayarin ng abogado) na nagmumula o may kaugnayan sa iyong paggamit ng Serbisyo, kabilang ang iyong nilalaman, iyong paggamit ng mga produkto o serbisyo na nauugnay sa Serbisyo, at iyong paglabag sa mga tuntuning ito o naaangkop na batas.',
    block21:
      '(b) mga Disclaimers. Ang Serbisyo ay ibinibigay nang "gaya nito." Sa lawak na pinapayagan ng batas, hindi kami at ang aming mga kaakibat at licensors ay gumagawa ng anumang representasyon o warranty tungkol sa Serbisyo at hindi gumagawa ng mga warranty, kabilang ngunit hindi limitado sa mga warranty ng merchantability, fitness para sa isang partikular na layunin, satisfactory quality, non-infringement, at tahimik na enjoyment, at anumang mga warranty na nagmumula sa kurso ng pakikitungo o paggamit ng kalakalan. Hindi namin ginagarantiya na ang Serbisyo ay magiging tuluy-tuloy, tumpak, o walang error, o na ang anumang Content ay magiging secure, hindi mawawala, o hindi mababago.',
    block22:
      '(c) Limitasyon ng Pananagutan. Hindi mananagot ang amin, ang aming mga kaakibat, o ang aming mga lisensiyado para sa anumang hindi direktang, hindi sinasadyang, espesyal, kahihinatnan, o parusang pinsala, kabilang ang pagkawala ng kita, pagkawala ng reputasyon, pagkawala ng paggamit, pagkawala ng data, o iba pang mga hindi materyal na pagkawala, kahit na nabigyan kami ng abiso tungkol sa posibilidad ng naturang mga pinsala. Sa ilalim ng mga tuntuning ito, ang aming kabuuang pananagutan ay hindi lalampas sa mga Bayad na ibinayad mo sa Serbisyo sa loob ng labindalawang (12) buwan bago ang paghahabol o isang daang dolyar US ($100), alinman ang mas malaki. Ang mga limitasyon sa seksyong ito ay nalalapat sa pinakamataas na lawak na pinapayagan ng naaangkop na batas.',
    block23:
      'Ang Mga Tuntunin at ang iyong paggamit ng Mga Serbisyo ay pinamamahalaan ng mga batas ng Estados Unidos, maliban sa mga patakaran ng U.S. conflict of laws. Ang iyong paggamit ng Aplikasyon ay maaari ring masailalim sa iba pang lokal, estado, pambansa o internasyonal na batas. Anumang legal na aksyon o proseso na nauugnay sa mga Tuntuning ito ay eksklusibong ihahain sa mga korte ng Estados Unidos, at sumasang-ayon kang magpasailalim sa personal na hurisdiksyon ng mga naturang korte.',
    block24:
      'Relasyon ng mga Partido. Si Noam at ikaw ay mga independiyenteng kontratista, at wala sa alinmang partido ang kapangyarihan na kumatawan o magbuklod sa kabilang partido o kumuha ng mga obligasyon para sa kabilang partido nang walang paunang nakasulat na pahintulot ng kabilang partido.',
    block25:
      '(b) Paggamit ng Brand. Hindi mo maaaring gamitin ang pangalan, mga logo, o mga trademark ng Noam o anumang mga kaakibat nito nang walang aming paunang pagsang-ayon na nakasulat.',
    block26:
      'Kung ang anumang probisyon ng mga tuntuning ito ay matukoy na hindi wasto, ilegal, o hindi maipatupad, ang natitirang mga probisyon ay mananatiling may buong bisa at epekto.',
    block3:
      'Kung ikaw ay wala pang 18 taong gulang, kailangan mong kumuha ng pahintulot mula sa iyong mga magulang o legal na tagapag-alaga upang gamitin ang Serbisyo. Kung ginagamit mo ang Serbisyo sa ngalan ng ibang tao o entidad, dapat kang awtorisado upang tanggapin ang mga tuntuning ito sa kanilang ngalan. Dapat kang magbigay ng tumpak at kumpletong impormasyon upang magrehistro para sa isang account. Hindi mo maaaring ibigay ang iyong mga access credential o account sa sinumang nasa labas ng iyong organisasyon, at ikaw ang mananagot sa lahat ng aktibidad na isinasagawa gamit ang iyong mga credential.',
    block4:
      '(a) Paggamit ng Serbisyo. Maaari kang mag-access sa Serbisyo alinsunod sa mga tuntuning ito, at binibigyan ka namin ng isang hindi eksklusibong karapatan na gamitin ang Serbisyo. Kapag gumagamit ng Serbisyo, dapat kang sumunod sa mga tuntuning ito at sa lahat ng naaangkop na batas. Kami at ang aming mga kaakibat ay nagmamay-ari ng lahat ng karapatan, titulo, at interes sa Serbisyo.',
    block5:
      '(b) Feedback. Nasisiyahan kami sa feedback, komento, ideya, mungkahi, at pagpapabuti. Kung magbibigay ka ng anumang nasabing nilalaman, maaari naming gamitin ito nang walang anumang mga restriksyon at walang kabayaran sa iyo.',
    block6:
      '(c) Mga Restriksyon. Hindi mo maaaring: (1) gamitin ang Serbisyo sa paraang lumalabag, nang-aagaw, o naglabag sa anumang karapatan ng iba; (2) mag-reverse engineer, decompile, disassemble, translate, o sa anumang paraan ayusin upang matuklasan ang source code o mga pinagbabatayan na bahagi ng mga modelo, algorithm, at sistema ng Serbisyo (maliban kung ang mga naturang restriksyon ay ipinagbabawal ng naaangkop na batas); (3) gamitin ang output ng Serbisyo upang bumuo ng mga modelo na nakikipagkumpitensya kay Noam; (4) kumuha ng data o output mula sa Serbisyo gamit ang anumang automated o programming na pamamaraan maliban kung pinahintulutan sa pamamagitan ng API, kabilang ang scraping, web harvesting, o web data extraction; (5) ipakita ang output ng Serbisyo bilang artipisyal na nabuo kung hindi naman ito ganoon, o sa anumang paraan ay lumabag sa aming mga patakaran sa paggamit; (6) bumili, magbenta, o maglipat ng mga API key nang walang aming paunang pahintulot; o (7) ibigay sa amin ang anumang personal na impormasyon ng mga bata na wala pang 13 taong gulang o naaangkop na edad ng digital na pahintulot. Dapat kang sumunod sa anumang rate limit at iba pang mga kinakailangan sa aming dokumentasyon.',
    block7:
      '(d) Mga Serbisyo ng Ikatlong Partido. Ang anumang software, serbisyo, o iba pang produkto ng ikatlong partido na nauugnay sa Serbisyo ay pinamamahalaan ng kanilang sariling mga tuntunin, at hindi kami responsable para sa mga produktong mula sa ikatlong partido.',
    block8:
      '(a) Iyong Nilalaman. Maaari kang magbigay ng input ("Input") sa Serbisyo at tumanggap ng output ("Output") na nabuo at ibinalik batay sa Input (pinagsama-samang tinutukoy bilang "Nilalaman"). Sa pagitan ng mga partido, at sa lawak na pinahihintulutan ng naaangkop na batas, ikaw ang nagmamay-ari ng lahat ng Input. Maaaring gamitin ni Noam ang Nilalaman upang ibigay at mapanatili ang Serbisyo, sumunod sa naaangkop na mga batas, at ipatupad ang aming mga patakaran. Ikaw ang may pananagutan sa Nilalaman, kabilang ang pagtiyak na hindi ito lumalabag sa anumang naaangkop na batas o mga tuntuning ito.',
    block9:
      '(b) Kumpletong Katumpakan. Ang artificial intelligence at machine learning ay mabilis na umuunlad na mga larangan ng pananaliksik. Patuloy naming sinisikap na pagbutihin ang aming serbisyo upang maging mas tumpak, mapagkakatiwalaan, ligtas, at kapaki-pakinabang. Dahil sa probabilistikong kalikasan ng machine learning, ang paggamit ng aming serbisyo ay maaaring magresulta ng mga maling output sa ilang mga kaso, na maaaring hindi tumpak na sumasalamin sa mga tunay na indibidwal, lugar, o katotohanan. Dapat mong wastong suriin ang katumpakan ng anumang output batay sa iyong gamit, kabilang ang pamamagitan ng manu-manong pagsusuri ng mga output.',
    subTitle1: 'Pagpaparehistro at Pag-access',
    subTitle10: 'Pagkakahiwalay',
    subTitle2: 'Mga Kinakailangan sa Paggamit',
    subTitle3: 'Nilalaman',
    subTitle4: 'Mga Bayad at Pagbabayad',
    subTitle5: 'Pagkakasekreto, Seguridad, at Proteksyon ng Datos',
    subTitle6: 'Termino at Pagwawakas',
    subTitle7: 'Kompensasyon; Pagwawaksi; Limitasyon ng Pananagutan',
    subTitle8: 'Nagpapatakbo ng Batas at Hurisdiksyon',
    subTitle9: 'Pangkalahatang Tuntunin',
    title: 'Mga Tuntunin ng Serbisyo',
    updateTime: 'Na-update: Marso 15, 2024',
  },
  trialModal: {
    btn: 'Simulan Na（Mga $0.99 Lamang）',
    chat: 'ChatPDF',
    desc1: 'Pagkatapos ng iyong pagsubok, sisingilin ka ng taunang bayad na $180',
    desc2: 'Maaaring I-cancel Kahit Kailan',
    focus: 'Pagtuon',
    hover: 'Pagsasalin sa hover',
    image: 'Pagsasalin ng larawan',
    installBtn: 'I-install na upang matanggap ang iyong regalo',
    memo: 'Pamamahala ng mga paborito',
    pdf: 'Parallel na pagsasalin ng PDF',
    realtime: 'Agad na pagsasalin',
    select: 'Pagsasalin ng pagpili ng salita',
    title: 'Pagbati na regalo',
    trialText: '7-Araw na Pagsubok',
    video: 'Pagsasalin ng video',
    videoSummary: 'Buod ng video',
    web: 'Parallel na Pagsasalin',
    webSummary: 'Buod ng web',
  },
  upgradeModal: {
    btn: 'I-upgrade Na',
    chat: {
      free: 'Naabot mo na ang limitasyon ng ChatPDF',
      pro: 'Naabot mo na ang limitasyon ng ChatPDF para sa buwang ito',
    },
    contactStr:
      'Mangyaring maghintay para sa susunod na pag-reset, o makipag-ugnayan sa amin sa contact@noam.tools.',
    limitAlertStr:
      'Naabot mo na ang limitasyon ng iyong libreng plano. Mag-upgrade upang magpatuloy.',
    more: 'Tingnan ang mga Plano',
    pageLimit: { free: 'Naabot mo na ang limitasyon ng pahina ng PDF' },
    title: 'Paalala',
    upgradeAlertStr:
      'Naabot mo na ang limitasyon ng iyong libreng plano. Mag-upgrade upang magpatuloy.',
    upload: {
      free: 'Naabot mo na ang iyong limitasyon sa pagsasalin ng PDF',
      pro: 'Naabot mo na ang iyong limitasyon sa pagsasalin ng PDF para sa buwang ito',
    },
  },
  welfare: {
    newUser: {
      joinBtn: 'Sumali Na',
      label: 'Mga Benepisyo para sa Bagong User:',
      remain: '30 nalang natitira',
      text: "Limang Daan na Pwesto Lang ang Available! Kunin Mo Na ang Sa'yo!",
    },
  },
  aiPdfTranslator: {
    title: 'Libreng AI PDF Translator: Isalin ang PDF na may Paghambing sa Anumang mga Wika',
    desc: 'Madaling isalin ang mga PDF file sa anumang wika gamit ang AI. Ihambing ang orihinal at isinalin na teksto nang magkatabi, mabilis at libre.',
    keywords: 'GPT-4、AI Assistant、Pagsasalin、Buod、Pokus、ChatPDF、Memo、kahusayan',
    sourceToTarget: {
      title: 'Libreng Tool sa Pagsasalin ng PDF: isalin ang {{source}} sa {{target}} nang libre',
      desc: 'I-translate ang iyong mga PDF file mula sa anumang pinagmulan ng wika patungo sa iyong gustong wika nang libre. Mabilis, tumpak, at ligtas na pagsasalin ng PDF na pinapagana ng advanced AI.',
    },
    headerIntroduce: {
      title: 'Noam: Higit Pa Lamang sa Online na Pagsasalin',
      introduce1: {
        title: 'Noam · Tagapagbasa ng PDF',
        desc: '✨Magkatabing pagsasalin + AI Q&A. Mabilis at tumpak na isasalin ang mga PDF sa iyong target na wika. Malayang magtanong tungkol sa nilalaman upang makakuha ng mas malalim na pag-unawa sa iyong mga PDF file.',
      },
      introduce2: {
        title: 'Noam · Extension ng Magkatabing Pagsasalin',
        desc: '👏Lutasin ang lahat ng pangangailangan mo sa pagsasalin ng webpage:',
        detail1: {
          title: 'Pagsasalin ng Webpage:',
          desc: 'Magkatabing dalawang-wika na pagtingin',
        },
        detail2: {
          title: 'Pagsasalin ng Salita:',
          desc: 'Mabilisang pagsasalin sa isang pag-click',
        },
        detail3: {
          title: 'Instant na Pagsasalin:',
          desc: 'Agad na isalin ang mga salita o pangungusap.',
        },
        detail4: {
          title: 'Pagsasalin ng Larawan:',
          desc: 'Palitan ang mga larawan ng mga nai-translate.',
        },
        detail5: {
          title: 'Pagsasalin ng Video:',
          desc: 'Bilinggwal na subtitle para sa mas mahusay na pagtingin.',
        },
        footer:
          'Mas maraming tampok sa pagbabasa na pinapagana ng AI para sa mas matalinong pagsasalin!',
      },
    },
    subtitle: 'I-translate ang PDF Online nang Libre',
    introduce: {
      module1: {
        detail1: {
          title: 'Real-Time Side-by-Side Pagsasalin ng PDF',
          desc1:
            'Agad na ipakita ang orihinal at isinalin na nilalaman sa isang magkakasabay, magkatabing layout',
          desc2: 'Madalas na ihambing ang parehong mga bersyon gamit ang synchronized scrolling',
          desc3: 'Mapanatili ang magkaparehong pormat para sa pare-parehong karanasan sa pagbabasa',
        },
        detail2: {
          title: 'Tumpak na Pagsasama-sama at Pagsusuri ng Nilalaman',
          desc1:
            'Perpektong pagkakahanay sa pagitan ng orihinal at isinalin na teksto para sa madaling pag-verify',
          desc2: 'Ang bawat bahagi ng nilalaman ay eksaktong tumutugma sa parehong mga bersyon',
          desc3:
            'Mabilis na makita at lutasin ang mga hindi pagkakatugma sa pagsasalin para sa maaasahang mga resulta',
        },
      },
      module2: {
        detail1: {
          title: 'Maramihang Advanced AI Models para sa Tumpak na Pagsasalin',
          desc1:
            'Pumili mula sa mga nangungunang modelo ng AI upang matugma sa iyong mga kinakailangan sa pagsasalin',
          desc2:
            "Tiyakin ang pinakamainam na mga resulta para sa iba't ibang uri ng dokumento at industriya",
          desc3:
            'Ang mga flexible na opsyon ng modelo ay nagbibigay ng mga sinasadyang solusyon para sa bawat sitwasyon',
        },
        detail2: {
          title: 'Advanced AI Translation para sa Bawat Uri ng Nilalaman',
          desc1:
            'Ang aming malakas na modelo ng AI ay nagtiyak ng mataas na katumpakan at natural na pag-unawa sa wika',
          desc2:
            'Mahusay na humahawak ng mga teknikal, akademiko, at malikhaing dokumento nang walang kahirapan',
          desc3:
            'Nagbibigay ng maaasahang mga resulta para sa lahat ng iyong pangangailangan sa pagsasalin',
          desc4:
            "Matalinong pag-aangkop sa iba't ibang uri ng nilalaman para sa pinakamainam na pagganap",
        },
      },
      module3: {
        detail1: {
          title: 'Intelligenteng Pakikipag-ugnayan sa Dokumento',
          desc1:
            'Madalasang makipag-usap sa iyong mga PDF at mga file ng presentasyon gamit ang advanced AI',
          desc2:
            'Agad na magtanong tungkol sa nilalaman ng dokumento at makatanggap ng tumpak na mga sagot',
          desc3: 'Mabilis na bumuo ng maigsi at tumpak na buod para sa mahahabang dokumento',
        },
        detail2: {
          title: 'Malalim na Pagsusuri ng Nilalaman at Walang Putol na Integrasyon',
          desc1:
            'Kunin ang mga pangunahing impormasyon at pag-aralan ang kumplikadong data gamit ang pag-unawa na pinapagana ng AI',
          desc2: 'Makakuha ng mga pananaw sa mga teknikal, akademiko, o malikhaing materyales',
          desc3:
            'Maaayos na nagsasama-sama sa aming PDF Translator para sa kumpletong solusyon sa pamamahala ng dokumento',
        },
      },
      module4: {
        detail1: {
          title: 'Higit sa PDF Translation: All-in-One Webpage Translation Solution',
          desc: 'Tuklasin ang aming makapangyarihang side-by-side na extension sa pagsasalin na idinisenyo para sa bawat sitwasyon ng pagbabasa online.',
          desc1:
            'Pagsasalin ng Webpage: Masisiyahan ka sa dalawang-wika na nilalaman gamit ang isang naka-sinkronisadong side-by-side na view',
          desc2:
            'Pagsasalin ng Salita: Agad na isalin ang mga naka-highlight na salita sa isang solong pag-click',
          desc3:
            'Instant na Pagsasalin: Isalin ang anumang teksto o pangungusap nang direkta para sa mabilis na pag-unawa',
          desc4:
            'Pagsasalin ng Larawan: Awtomatikong palitan ang orihinal na mga larawan ng mga isinalin na bersyon',
          desc5:
            'Pagsasalin ng Video: Panoodin ang mga video na may dalawang wika na subtitle para sa mas pinahusay na karanasan',
        },
      },
    },
    question: {
      title: 'Madalas Itanong na Mga Tanong',
      answer1: {
        title: 'Gratis bang gamitin ang Noam PDF Translator para sa pagsasalin ng PDF?',
        content:
          'Oo, maaari kang mag-translate ng mga PDF nang libre gamit ang Sider PDF Translator! Nag-aalok kami ng libreng quota na 5,000 token, na sapat upang isalin ang karamihan sa mga PDF dokumentong karaniwang makikita sa merkado. Kung kailangan mong isalin ang mas malalaking file o nangangailangan ng mga advanced na feature, maaari mong piliing i-upgrade sa aming premium na mga plano para sa higit pang mga kakayahan.',
      },
      answer2: {
        title: 'Gaano katumpak ang Noam PDF Translator?',
        content:
          "Ang Noam PDF Translator ay nagbibigay ng lubos na tumpak na pagsasalin sa pamamagitan ng paggamit ng advanced na teknolohiyang AI at malalim na pag-unawa sa konteksto ng iyong mga dokumento. Bagama't walang automated na pagsasalin ang perpekto, ang aming side-by-side na display ay nagbibigay-daan sa iyo na madaling suriin at ayusin ang bawat pagsasalin, tinitiyak na ang huling resulta ay nakakatugon sa iyong mga inaasahang kalidad. Maranasan ang maaasahan at tumpak na pagsasalin ng PDF kasama ang Noam.",
      },
      answer3: {
        title: 'Maaari ko bang isalin ang mga scanned na PDF?',
        content:
          'Oo, maaari mong isalin ang mga nai-scan na PDF gamit ang aming built-in OCR (Optical Character Recognition) teknolohiya. Ang aming sistema ay awtomatikong kumukuha ng teksto mula sa mga nai-scan na dokumento at image-based na PDF, pagkatapos ay isinasalin ang nilalaman para sa iyo. Tinitiyak nito na kahit na ang mga hindi ma-edit o image-only na PDF ay maaaring tumpak na isalin.',
      },
      answer4: {
        title: 'Gaano katagal ang proseso ng pagsasalin?',
        content:
          'Ang pagsasalin ay mabilis at epektibo—karamihan sa mga dokumento ay napoproseso sa loob ng ilang segundo hanggang ilang minuto, depende sa kanilang haba at pagiging kumplikado. Halimbawa, ang isang karaniwang 10-pahinang PDF ay karaniwang tumatagal ng mas mababa sa 2 minuto upang isalin. Tangkilikin ang mabilis na oras ng pagbabalik para sa lahat ng iyong mga pangangailangan sa pagsasalin ng dokumento!',
      },
      answer5: {
        title: 'Maaari ko bang panatilihin ang side-by-side na view para sa pagbabasa?',
        content:
          'Oo, palaging maaari mong basahin ang iyong mga dokumento nang magkatabi. Ang layout na ito ay nagbibigay-daan sa iyo na madaling ihambing ang orihinal at isinalin na nilalaman, na nagsisiguro ng isang maayos at epektibong karanasan sa pagbabasa.',
      },
    },
    freeTrial: 'Libreng Pagsubok',
    toLanguage: {
      title: 'Mga Pares ng AI Pagsasalin sa PDF',
      item: '{{source}} patungo sa {{target}}',
    },
  },
  aiPdfTranslate: {
    header: {
      pricing: 'Presyo',
      button: 'I-translate Na',
      blog: 'Blog',
      features: 'Mga Tampok',
      faq: 'MGA KARANIWANG TANONG',
    },
    hero: {
      upload: {
        title: 'I-upload ang iyong PDF',
        highlight: 'I-click upang mag-browse',
        max: 'Max',
        desc: 'o i-drag at i-drop',
      },
      to: 'sa',
      pill: 'AI-Powered na Tagasalin ng PDF',
      title: 'Libreng Tagasalin ng PDF',
      desc: 'Mabilis, tumpak na pagsasalin na nagpapanatili ng orihinal na layout. Sinusuportahan ng Noam AI ang OCR at mga side-by-side na view.',
      support: 'Soporte sa OCR',
      free: 'Libreng Pagsubok',
      model: 'GPT-4 at Claude',
      translated: 'Nai-translate ni Noam',
      complete: 'Kumpletong Pagsasalin',
    },
    ticker: {
      ocr: 'Teknolohiyang OCR',
      pdf: 'Pagsasalin ng PDF',
      multi: 'Maramihang Wika',
      format: 'Pagpapanatili ng Format',
      side: 'Magkatabi',
      chat: 'Makipag-chat sa PDF',
      secure: 'Ligtas at Private',
      web: 'Web na Pagsasalin',
    },
    comparison: {
      bad: {
        title: 'Pamantayang Pagsasalin',
        head: 'Nawala ang Pormat at Konteksto',
        text1: 'Error: Sira ang layout. Naligaw ng pwesto ang mga larawan.',
        text2:
          'Ang mga teksto ay nag-o-overlap at hindi pare-pareho ang mga font. Mahirap basahin at hindi propesyonal...',
      },
      dump: { title: 'Plain Text Dump' },
      good: {
        title: 'Pagsasalin ng Noam AI',
        tag: 'Perpektong Resulta',
        sub: 'Perpektong Pormat, May Kamalayan sa Konteksto',
      },
      title: 'Bakit Pumili ng Noam AI?',
      desc: 'Huwag nang maghirap sa copy-paste na pagsasalin. Naranasan ang pagkakaiba sa pagitan ng mga karaniwang tool at ng aming AI-powered na context-aware na pagsasalin.',
    },
    showcase: {
      kicker: 'MGA SUPORTADONG DOKUMENTO',
      title1: 'Anumang Dokumento',
      title2: 'Anumang Wika',
      carousel2: 'Arkitektura',
      carousel1: 'Sining',
      note: 'Madaling hawakan ang mga teknikal, akademiko, at malikhaing dokumento.',
      carousel4: 'Gamot',
      carousel3: 'Pampelikulang journal',
      carousel6: 'Batas',
      carousel5: 'Pananalapi',
      carousel7: 'Kontrata',
      carousel8: 'Patakaran',
    },
    features: {
      big: {
        title: 'Mga Advanced na AI Modelo (GPT-4, Claude)',
        desc: "Pumili mula sa nangungunang mga modelo ng AI upang tumugma sa iyong mga kinakailangan sa pagsasalin. Tiyaking magkaroon ng pinakamainam na mga resulta para sa iba't ibang uri ng dokumento.",
      },
      grid1: {
        title: 'Soporte sa OCR',
        desc: 'Kunan at isalin agad ang teksto mula sa mga nai-scan na PDF at larawan.',
      },
      grid2: {
        title: 'Pag-export ng Mataas na Resolution',
        desc: 'I-download ang iyong mga nai-translate na dokumento sa PDF format na may orihinal na layout.',
      },
      grid3: {
        title: 'Pagsusuri ng Magkatabi',
        desc: 'Synchronized na pag-scroll upang ihambing ang orihinal at isinalin na teksto.',
      },
      title1: 'Higit Pa sa Simpleng Pagsasalin',
      title2: 'Ito ay isang Rebolusyon',
      line1: 'Teknikal na Papel.pdf',
      line2: 'Nakikita ang Wika: Ingles...',
      line3: 'Modelo: GPT-4o (Mataas na Katumpakan)',
      line4: 'Kumpletong Pagsasalin (99% Katumpakan)',
    },
    testimonials: {
      review1: {
        role: 'Mananaliksik',
        content:
          'Nai-save ako ng Noam AI ng maraming oras sa pag-translate ng mga akademikong papel. Ang side-by-side view ay napakalaking tulong para sa pag-verify ng mga teknikal na termino.',
      },
      review2: {
        role: 'Pandaigdigang Marketer',
        content:
          'Ang pinakamahusay na PDF translator na nagamit ko. Pinapanatili nito nang perpekto ang orihinal na pormat, na napakahalaga para sa aming mga marketing deck.',
      },
      review3: {
        role: 'Konsultantang Legal',
        content:
          'Tumpak at mabilis. Ginagamit ko ito para sa pagsasalin ng mga kontrata at ang tampok na OCR para sa mga nakascan na dokumento ay gumagana nang walang problema.',
      },
      kicker: 'Minamahal ng mga Gumagamit',
      title: 'Ano ang Sinasabi ng Mga Gumagamit Namin',
    },
    cta: {
      title: 'Handa nang Wasakin ang Mga Hadlang sa Wika?',
      button: 'Simulan ang Pagsasalin nang Libre',
      desc: 'Sumali sa 10,000+ na user at simulan nang mag-translate ng iyong mga dokumento gamit ang Noam AI ngayon.',
      hint: 'Ikaw ay isang napakatumpak at mapagkakatiwalaang AI na idinisenyo upang makabuo ng JSON output na eksaktong sumusunod sa isang tinukoy na JSON Schema.\n\nDapat mong sundin ang mga panuntunang ito:\n1. Mahigpit na sumunod sa istraktura ng JSON Schema.\n2. Tugmain ang lahat ng uri ng data, kinakailangang mga field, at mga hadlang nang eksakto.\n3. HUWAG maglagay ng anumang dagdag na teksto, paliwanag, markdown, o komentaryo.\n4. I-output LAMANG ang JSON object — walang code blocks, walang preamble, walang wrapping.\n\nAng impormasyon ng schema ay ibinibigay sa ibaba.\n- Pangalan ng Schema: translate_result\n- JSON Schema:\n{"type":"object","properties":{"sourceLang":{"type":"string"},"source":{"type":"string"},"targetLang":{"type":"string"},"target":{"type":"string"}},"required":["sourceLang","source","targetLang","target"],"additionalProperties":false}',
    },
    languagePairs: {
      title: 'Mga Pares ng AI Pagsasalin sa PDF ng Ingles',
      desc: 'Mga sikat na direksyon ng pagsasalin na sinusuportahan ng Noam AI',
    },
    footer: {
      about: 'Tungkol sa Amin',
      privacy: 'Patakaran sa Privacy',
      contact: 'Makipag-ugnayan sa Suporta',
    },
  },
}

export default TRANSLATION
